import { NotFound } from '@fukuri-admins/ui/common/errors';
import { ToastProvider } from '@fukuri-admins/ui/common/Toast/provider';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { AuthProvider } from './components/auth/AuthProvider';
import { ProtectedRoute } from './components/auth/ProtectedRoute';
import { PublicRoute } from './components/auth/PublicRoute';
import { DashboardLayout } from './components/layouts/DashboardLayout';
import { ShowCompany } from './pages/Company/Show';
import { IndexCompanyDeposit } from './pages/CompanyDeposit/Index';
import { Login } from './pages/Login';
import { IndexPaymentReport } from './pages/PaymentReport/Index';
import { IndexRedeemableStoreCouponHistory } from './pages/RedeemableStoreCouponHistory/Index';

function App() {
  return (
    <BrowserRouter>
      <ToastProvider>
        <AuthProvider>
          <Routes>
            <Route element={<PublicRoute />}>
              <Route path='/login' element={<Login />} />
            </Route>
            <Route element={<ProtectedRoute />}>
              <Route element={<DashboardLayout />}>
                <Route path='/payment_reports' element={<IndexPaymentReport />} />
                <Route path='/company' element={<ShowCompany />} />
                <Route path='company_deposits/' element={<IndexCompanyDeposit />} />
                <Route
                  path='/redeemable_store_coupon_histories'
                  element={<IndexRedeemableStoreCouponHistory />}
                />
              </Route>
            </Route>
            <Route path='/' element={<Navigate to='/login' replace />} />
            <Route path='*' element={<NotFound />} />
          </Routes>
        </AuthProvider>
      </ToastProvider>
    </BrowserRouter>
  );
}

export default App;
